import React from 'react';
import styles from './Backdrop.scss';
import PropTypes from 'prop-types';

const backdrop = props => {
  return props.show ? (
    <div
      className={styles.backdrop}
      onClick={props.onClick}
    />
  ) : null;
};

backdrop.propTypes = {
  show: PropTypes.bool,
  onClick: PropTypes.func,
};

export default backdrop;
